import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { ROUTE_CONSTANTS } from '../../../shared/constants/Route';
import { useLocation } from 'react-router-dom';

import './style.scss';

const DATA = [
  {
    title: 'Flash Cards',
    path: ROUTE_CONSTANTS.ROOT,
    active: require('../../../Assets/Images/Icons/flashcard_white.png'),
    inactive: require('../../../Assets/Images/Icons/flashcard.png'),
  },
  {
    title: 'Questions',
    path: ROUTE_CONSTANTS.QUESTIONS,
    active: require('../../../Assets/Images/Icons/question_white.png'),
    inactive: require('../../../Assets/Images/Icons/question.png'),
  },
  {
    title: 'Videos',
    path: ROUTE_CONSTANTS.VIDEOS,
    active: require('../../../Assets/Images/Icons/video_white.png'),
    inactive: require('../../../Assets/Images/Icons/video.png'),
  },
  {
    title: 'Simulated Tests',
    path: ROUTE_CONSTANTS.SIMULATDED_TESTS,
    active: require('../../../Assets/Images/Icons/tests_white.png'),
    inactive: require('../../../Assets/Images/Icons/tests.png'),
  },
  {
    title: 'Dashboard',
    path: ROUTE_CONSTANTS.DASHBOARD,
    active: require('../../../Assets/Images/Icons/dashboard_white.png'),
    inactive: require('../../../Assets/Images/Icons/dashboard.png'),
  },
];

const DrawerList = ({
  onClick = () => {
  },
}) => {
  let { pathname } = useLocation();
  return (
    <div className='leftSidebar'>
      <div className='admin-logo'>
        <img
          src={require(`../../../Assets/Images/logo.png`)}
          alt='Prep2Pass'
          className='img-fluid'
        />
      </div>
      <List className='sidebar_menu'>
        {DATA.map((item, index) => {
          let { title, active, inactive, path } = item;
          let sameRoute =
            path == ROUTE_CONSTANTS.ROOT
              ? path == pathname ||
              pathname.includes(ROUTE_CONSTANTS.DISPLAY_FLASH)
              : pathname.includes(path);
          return (
            <ListItem
              className={sameRoute ? 'active' : ''}
              button
              key={index}
              onClick={() => onClick(path)}
            >
              <div
                className='nav-item'
                style={
                  {
                    // backgroundColor: sameRoute ? SECONDARY_DARK_COLOR : 'transparent',
                  }
                }
              >
                <i>
                  <img
                    src={sameRoute ? active : inactive}
                    style={{ width: 20, height: 20 }}
                    alt=''
                  />
                </i>
                <span>{title}</span>
              </div>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};
export default DrawerList;
